import styled from 'styled-components';
import { media } from '@minecraft.themes';
import { Modal } from 'reactstrap';

interface SmallModal {
  $isSmall: boolean;
}

export const StyledModal = styled(Modal)<SmallModal>`
  max-width: 100vw;
  height: 100vh;
  margin: 0;
  background-color: ${(props) => props.theme.colors.primary.black}b3;
  .modal-content {
    min-height: ${(props) => (props.$isSmall ? 'auto' : '100%')};
    height: 100vh;
    margin: auto;
    background: transparent;
    border: none;
  }

  .modal-header {
    align-items: center;
    border: 0;
    color: ${(props) => props.theme.colors.primary.white};
    padding: 1rem 1rem 2rem 1rem;
  }

  .close {
    color: ${(props) => props.theme.colors.primary.white};
    margin: 0;
    opacity: 1;
    padding: 0;
    text-shadow: 0 0 0 ${(props) => props.theme.colors.primary.white};

    &:not(.disabled):hover,
    &:not(.disabled):focus {
      opacity: 1;
      color: ${(props) => props.theme.colors.primary.white};
    }
  }

  .modal-body {
    padding: 0;
  }

  .image-gallery {
    height: 100%;
  }

  .image-gallery-content.bottom {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Slider styles */
  .image-gallery-slides {
    line-height: 1;
  }

  .image-gallery-slide.center {
    z-index: 1;
    outline: 0;
  }

  .image-gallery-swipe {
    align-items: center;
    display: flex;
    justify-content: center;
    /* Height of the video element */
    min-height: 24.75rem;
    height: 100%;
  }

  .image-gallery-index {
    background: none;
    margin-top: 1.75rem;
    font-size: 0.875rem;
    font-weight: normal;
    left: 0;
    right: 0;
    text-align: center;
    top: initial;
    padding: 0 2.5rem 1rem;
  }

  .image-gallery-slide {
    flex-direction: column;
    align-items: center;
  }

  .image-gallery-slide-wrapper.bottom {
    height: 100%;
    padding: 0 6px;
    & > .image-gallery-slides {
      align-items: center;
      display: flex;
      justify-content: center;
      height: 100%;
    }
  }

  .image-gallery-thumbnails-wrapper.bottom {
    display: none;
  }
  .image-gallery-thumbnails {
    padding: 1.25rem 0;
  }

  .image-gallery-thumbnail {
    border: none;
    vertical-align: middle;
    width: auto;

    & > * {
      opacity: 0.4;
      transition: opacity 0.25s;
    }

    &:not(:first-of-type) {
      margin-left: 1.75rem;
    }

    &:hover,
    &:focus {
      border: none;
    }

    &.active {
      border: none;

      & > * {
        opacity: 1;
      }
    }
  }

  ${media.sm`
      width: 100vw;

      .modal-content {
        width: 100vw;
      }
      .modal-header {
          padding: 1.5rem 3rem 0 3rem;
      }

      .image-gallery-thumbnails-wrapper.bottom {
        border-top: 1px solid ${(props) => props.theme.colors.primary.ltGrey1};
        display: block;
        padding: 0 12.5%;
      }
      .image-gallery-slide-wrapper.bottom {
        padding: 0;
      }

      .image-gallery-index {
        bottom: 0;
        text-align: right;
      }
  `}
`;

export const StyledCloseButton = styled.button`
  color: ${(props) => props.theme.colors.primary.white};
  opacity: 1;
  text-shadow: 0 0 0 ${(props) => props.theme.colors.primary.white};

  &:not(.disabled):hover,
  &:not(.disabled):focus {
    color: ${(props) => props.theme.colors.primary.white};
    opacity: 1;
  }
  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const StyledPrevButton = styled.button`
  background-color: transparent;
  border-bottom: 3.6vh solid transparent;
  border-left: none;
  border-right: 3.6vh solid ${(props) => (props.disabled ? 'transparent' : 'white')};
  border-top: 3.6vh solid transparent;
  display: none;
  height: 0;
  left: 5.5%;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: border-color 0.25s;
  width: 0;
  z-index: 1;
  &:hover {
    border-right-color: #eee;
  }

  ${media.sm`
    display: block;
  `}
`;

export const StyledNextButton = styled.button`
  background-color: transparent;
  border-bottom: 3.6vh solid transparent;
  border-left: 3.6vh solid ${(props) => (props.disabled ? 'transparent' : 'white')};
  border-right: none;
  border-top: 3.6vh solid transparent;
  display: none;
  height: 0;
  padding: 0;
  position: absolute;
  right: 5.5%;
  top: 50%;
  transform: translateY(-50%);
  transition: border-color 0.25s;
  width: 0;
  z-index: 1;
  &:hover {
    border-left-color: #eee;
  }

  ${media.sm`
    display: block;
  `}
`;

export const ThumbNextButton = styled(StyledNextButton)`
  border-bottom: 1vh solid transparent;
  border-left: 1vh solid ${(props) => (props.disabled ? 'transparent' : 'white')};
  border-top: 1vh solid transparent;
  right: 5.5%;
  top: auto;
  bottom: calc(1.5rem + 3vh);
  transform: none;
  &:hover {
    border-left-color: #eee;
  }
  display: block;
`;

export const ThumbPrevButton = styled(StyledPrevButton)`
  border-bottom: 1vh solid transparent;
  border-right: 1vh solid ${(props) => (props.disabled ? 'transparent' : 'white')};
  border-top: 1vh solid transparent;
  border-left: none;
  left: 5.5%;
  top: auto;
  bottom: calc(1.5rem + 3vh);
  transform: none;
  &:hover {
    border-left-color: #eee;
  }
  display: block;
`;

export const ThumbNav = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
